import { fn } from 'storybook/test';

import type { Meta, StoryFn } from '@storybook/react';
import type { CheckboxProps } from './Checkbox';

import { Checkbox } from './Checkbox';

import { FormField } from 'components/FormField';
import { Label } from 'components/Label';

const codeString = '<Checkbox checked={} id={} onChange={} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Checkbox',
  component: Checkbox,
  parameters: {
    inspectComponent: Checkbox,
    codeString: codeString,
  },
} as Meta<CheckboxProps>;

const Template: StoryFn<CheckboxProps> = (args) => (
  <FormField inline>
    <Checkbox id="72103b4d" {...args} />
    <Label htmlFor="72103b4d">Example Checkbox</Label>
  </FormField>
);

export const CheckboxExample = Template.bind({});
CheckboxExample.args = {
  onChange: fn(),
};

// Extra story created for UX to see how we can solve placement of checkbox when paired with long content
// TODO: should this component be refactored to always include a label? (see RadioButton)
const WithLongLabelTemplate: StoryFn<CheckboxProps> = (args) => (
  <FormField inline>
    <div
      style={{
        alignSelf: 'flex-start',
        marginTop: '0.18rem',
      }}
    >
      <Checkbox id="72103b4e" {...args} />
    </div>
    <Label htmlFor="72103b4e">
      Example Checkbox with long long long long long long long long long long long long long long long long long long
      long long long long long long long long long long long long long long long long long long long long long long long
      long long long long long long long long long long long long long long long long long long long long long long long
      long long long long long long long long long long long label
    </Label>
  </FormField>
);

export const WithLongLabel = WithLongLabelTemplate.bind({});
WithLongLabel.args = {
  onChange: fn(),
};
